import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/components/LanguageContext";
import { scrollToId } from "@/lib/scroll";
import { LogoMark } from "@/components/Navigation";

const Footer = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const year = new Date().getFullYear();
  const links = [
    { id: "top", label: t.nav.home },
    { id: "leistungen", label: t.nav.services },
    { id: "eroeffnung", label: t.nav.eroeffnung },
    { id: "prozess", label: t.nav.process },
    { id: "pakete", label: t.nav.packages },
    { id: "branchen", label: t.nav.industries },
  ];

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) {
      scrollToId(id);
    } else {
      navigate("/");
      setTimeout(() => scrollToId(id), 500);
    }
  };

  return (
    <footer className="bg-[#101113] pt-20 text-bone" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-16">
        <div className="grid grid-cols-1 gap-12 border-b border-bone/10 pb-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="flex items-center gap-3">
              <LogoMark size={40} />
              <span className="flex flex-col items-start leading-none">
                <span className="font-display text-3xl font-bold tracking-[0.3em]">JOUDI</span>
                <span className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.5em] text-gold">Group</span>
              </span>
            </span>
            <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.3em] text-bone/70">
              {t.footer.tagline}
            </p>
            <a
              href="mailto:jean@joudi-group.com"
              data-testid="footer-email"
              className="link-underline mt-5 inline-block text-sm text-bone/80 transition-colors hover:text-gold"
            >
              jean@joudi-group.com
            </a>
          </div>
          <div className="lg:col-span-4">
            <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-gold">{t.footer.navTitle}</h4>
            <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
              {links.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => go(l.id)}
                    className="link-underline text-sm text-bone/70 transition-colors hover:text-bone"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-gold">{t.footer.legalTitle}</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <button
                  data-testid="footer-imprint"
                  onClick={() => navigate("/impressum")}
                  className="link-underline text-bone/70 transition-colors hover:text-bone"
                >
                  {t.footer.imprint}
                </button>
              </li>
              <li>
                <button
                  data-testid="footer-privacy"
                  onClick={() => navigate("/datenschutz")}
                  className="link-underline text-bone/70 transition-colors hover:text-bone"
                >
                  {t.footer.privacy}
                </button>
              </li>
            </ul>
            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.35em] text-bone/40">{t.footer.motto}</p>
          </div>
        </div>

        <div className="select-none py-10" aria-hidden="true">
          <svg viewBox="0 0 1000 132" className="h-auto w-full" preserveAspectRatio="xMidYMid meet">
            <text
              x="500"
              y="106"
              textAnchor="middle"
              textLength="988"
              lengthAdjust="spacingAndGlyphs"
              fontFamily="Sora, 'Helvetica Neue', Helvetica, Arial, sans-serif"
              fontWeight="700"
              fontSize="128"
              fill="#F0EDE6"
              fillOpacity="0.95"
            >
              JOUDI GROUP
            </text>
          </svg>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-bone/10 py-8 sm:flex-row">
          <p className="text-xs text-bone/50">© {year} Joudi Group · Peyia, Paphos, Zypern. {t.footer.rights}</p>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-bone/40">Peyia · 34.88° N, 32.37° O</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
